module.exports = __webpack_public_path__ + "img/ic_home_notifications@2x.1470ad4.png";